import {css} from 'styled-components';

import {
	alpha,
	getBorderColor,
	getDimmedTextColor,
	getBackgroundShade,
} from 'utils/ui/colors';
import {spacing} from 'styles/globals';

export const textInputProps = ['stealthy', 'isActive'];

export const textInputReset = css`
	position: relative;

	margin: 0;
	padding: ${spacing.xs};

	font: inherit;
	color: inherit;
	background-color: transparent;

	border: none;
	border-radius: 0;
	box-shadow: none;
`;

export const textInputStyle = css`
	${textInputReset}

	display: block;
	width: 100%;

	color: ${p => p.theme.text};
	background-color: ${p => p.theme.background};
	border: 1px solid ${p => getBorderColor(p.theme)};
	${p =>
		p.stealthy &&
		css`
			border: none;
			border-bottom: 1px dashed ${p => alpha(p.theme.shade, 0.5)};
		`}

	transition:
		all 250ms linear,
		height 0ms linear;

	cursor: text;
	resize: vertical;

	&[disabled] {
		cursor: not-allowed;
		color: ${p => getDimmedTextColor(p.theme)};
		border-color: transparent;
		background-color: ${p => getBackgroundShade(p.theme)};
	}

	&:not([disabled]):hover {
		background-color: ${p => getBackgroundShade(p.theme)};
	}

	&:not([disabled]):focus {
		background-color: ${p => getBackgroundShade(p.theme)};
		border-color: ${p => p.theme.links};
		border-bottom-style: solid;
		box-shadow: 0 3px 0 ${p => p.theme.links};
	}

	${p =>
		p.isActive &&
		css`
			&:not([disabled]) {
				background-color: ${p => getBackgroundShade(p.theme)};
				border-color: ${p => p.theme.links};
				border-bottom-style: solid;
				box-shadow: 0 3px 0 ${p => p.theme.links};
			}
		`}
`;
